import React, { Component } from "react";
import { Table, Button } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';

class AssessmentListTable extends Component {
    render() {
        return (
        <Table>
            <tbody>
            {this.props.departments.map((dept, index) =>
                <tr key={index}>
                    <td>{dept.school}</td>
                    <td>{dept.name}</td>
                    <td>
                        {dept.dateModified
                            ? <>
                                {'Modified ' + dept.dateModified}
                            </>
                            : <></>
                        }
                    </td>
                    <td style={{textAlign: "right"}}>
                    { dept.departmentAssessmentId
                        ?<>
                        <LinkContainer
                            to={'/assessment/edit/' + dept.departmentAssessmentId}
                            >
                            <Button
                                href=""
                                size="md"
                                >
                                Modify
                            </Button>
                        </LinkContainer>
                        &nbsp;&nbsp;
                        <LinkContainer
                            to={{pathname:'/assessment/view', search:'?d=' + dept.departmentAssessmentId}}>
                            <a href={'/assessment/view?d=' + dept.departmentAssessmentId}
                                className="btn btn-outline-primary pull-right"
                                role="button">
                                View
                            </a>
                        </LinkContainer>
                        </>
                        :
                        <LinkContainer 
                            to={{
                                pathname: '/assessment/new',
                                search: '?d=' + dept.id,
                            }}
                            >
                            <Button
                                href={'/assessment/new?d=' + dept.id}
                                disabled={dept.submittedProgramsCount < 1}
                                variant="success"
                                size="md"
                                className="w-50"
                                >
                                Create
                            </Button>
                        </LinkContainer>
                    }
                    </td>
                </tr>
            )}
            </tbody>
        </Table>
        )
    }
}

export default AssessmentListTable;